"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProgressBar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _utils = require("../utils");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProgressBar = _ref => {
  let {
    color,
    value,
    className,
    size,
    small,
    limit,
    label,
    comment
  } = _ref;
  const classes = (0, _styles.useStyles)();
  const [success, setSuccess] = (0, _react.useState)(false);
  const handleClass = () => {
    if (limit && success) {
      return classes.readerBarP;
    }
    if (!limit && success) {
      return classes.barSuccess;
    }
    return classes.bar;
  };
  (0, _react.useEffect)(() => {
    if (value === 100) {
      setSuccess(true);
    } else {
      setSuccess(false);
    }
  }, [value, setSuccess]);
  if (label || comment) return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrapper,
    style: {
      width: (0, _utils.checkSize)(size)
    }
  }, label && /*#__PURE__*/_react.default.createElement("p", {
    className: classes.label
  }, label), /*#__PURE__*/_react.default.createElement(_core.LinearProgress, {
    style: {
      height: `${small ? '10px' : '24px'}`
    },
    classes: {
      root: classes.root,
      bar: handleClass()
    },
    variant: "determinate",
    value: value,
    color: "secondary",
    className: className,
    limit: limit
  }), comment && /*#__PURE__*/_react.default.createElement("p", {
    className: classes.comment
  }, comment));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.LinearProgress, {
    style: {
      width: (0, _utils.checkSize)(size),
      height: `${small ? '10px' : '24px'}`
    },
    classes: {
      root: classes.root,
      bar: handleClass()
    },
    variant: "determinate",
    value: value,
    color: color,
    className: className,
    limit: limit
  }));
};
exports.ProgressBar = ProgressBar;
ProgressBar.propTypes = {
  /**
   * Cor do ProgressBar
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']),
  /**
   * Object classes
   */
  className: _propTypes.default.string,
  /**
   * Valor do indicador de progesso, varia de 0 a 100
   */
  value: _propTypes.default.number.isRequired,
  /**
   * Seleciona o tamanho do progressBar
   */
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'full']),
  /**
   * Se 'True', a progress bar tem uma altura menor
   */
  small: _propTypes.default.bool,
  /**
   * Se 'True', a cor de 100% se torna cinza
   */
  limit: _propTypes.default.bool,
  /**
   * Texto que acompanha a progress bar
   */
  label: _propTypes.default.string,
  /**
   * Texto que acompanha a progress bar embaixo
   */
  comment: _propTypes.default.string
};
ProgressBar.defaultProps = {
  color: 'primary',
  className: '',
  size: 'md',
  small: false,
  limit: false,
  label: null,
  comment: null
};
var _default = exports.default = ProgressBar;